import ServiceTemplate from '@/components/ServiceTemplate';

export default function PatentSearch() {
  const data = {
    title: 'Patent Search Services',
    subtitle: 'Comprehensive patent searches to evaluate novelty and patentability of your invention.',
    overviewTitle: 'Why Conduct a Patent Search?',
    overviewImage: 'https://images.unsplash.com/photo-1532619675605-1ede6c2ed2b0',
    description: [
      'Before investing significant time and resources in a patent application, conducting a thorough patent search is essential. Our comprehensive searches identify existing patents and prior art that could affect your invention\'s patentability.',
      'We search U.S. and international patent databases, scientific literature, and technical publications to provide a complete picture of the patent landscape in your field.',
      'Our experienced patent attorneys analyze search results and provide strategic recommendations on patentability, potential claims, and competitive positioning.'
    ],
    benefits: [
      { title: 'Cost Savings', description: 'Avoid expensive application fees if prior art exists.' },
      { title: 'Strategic Planning', description: 'Identify opportunities to strengthen your patent claims.' },
      { title: 'Risk Assessment', description: 'Understand potential infringement risks before market entry.' },
      { title: 'Competitive Intelligence', description: 'Learn what competitors have patented in your field.' },
      { title: 'Investment Decisions', description: 'Make informed decisions about R&D investments.' },
      { title: 'Expert Analysis', description: 'Receive detailed analysis from experienced patent attorneys.' }
    ],
    process: [
      { title: 'Research & Analysis', description: 'Comprehensive search and analysis to identify potential conflicts or issues.' },
      { title: 'Application Preparation & Filing', description: 'Expert preparation and filing of complete applications with all required documentation.' },
      { title: 'Monitoring & Approval', description: 'Track application progress and address any office actions until successful approval.' }
    ],
    pricing: [
      {
        name: 'Consultation',
        description: 'Patent evaluation',
        price: '$499',
        period: 'One-time fee',
        features: [
          'Patentability assessment',
          'Prior art search',
          'Patent strategy consultation',
          'Feasibility analysis',
          'Written opinion',
          'Filing recommendations'
        ]
      },
      {
        name: 'Utility Patent',
        description: 'Full patent application',
        price: '$5,999',
        period: '+ USPTO fees ($1,820)',
        featured: true,
        features: [
          'Everything in Consultation',
          'Complete patent drafting',
          'USPTO filing',
          'Office action responses (2 included)',
          'Prior art analysis',
          'Claims optimization',
          'Direct attorney access'
        ]
      },
      {
        name: 'Design Patent',
        description: 'Design protection',
        price: '$1,999',
        period: '+ USPTO fees ($860)',
        features: [
          'Design patent search',
          'Professional patent drawings',
          'Complete application',
          'USPTO filing',
          'Office action response (1 included)',
          'Expedited processing available',
          'Priority support'
        ]
      }
    ],
    faqs: [
      { question: 'How long does a patent search take?', answer: 'Comprehensive patent searches typically take 5-10 business days depending on the complexity of the invention and field.' },
      { question: 'Is a patent search required?', answer: 'While not legally required, conducting a patent search is strongly recommended to assess patentability and avoid wasted application costs.' },
      { question: 'What if prior art is found?', answer: 'We help you evaluate whether to modify your invention, pursue narrower claims, or explore alternative protection strategies.' },
      { question: 'Do you search international patents?', answer: 'Yes, we search major international patent databases to identify relevant prior art from around the world.' },
      { question: 'How detailed is the search report?', answer: 'Reports include identified prior art, similarity analysis, patentability assessment, and strategic recommendations.' },
      { question: 'Can I conduct my own search?', answer: 'While possible, professional searches by experienced patent attorneys are more thorough and provide expert analysis crucial for decision-making.' },
      { question: 'What databases do you search?', answer: 'We search USPTO, EPO, WIPO, Google Patents, scientific journals, and technical publications relevant to your field.' },
      { question: 'What happens after the search?', answer: 'We review results with you, assess patentability, and recommend whether to proceed with application or make modifications.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
